import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./App.scss";

import Explore from "./pages/explore/explore";
import OutletDetail from "./pages/outlet-detail/outlet-detail";
import Paybill from "./pages/paybill/paybill";
import Profile from "./pages/profile/profile";
import Search from "./pages/search-city/search-city";
// import BillAmount from "./pages/bill-amount/bill-amount";
import BreakUp from "./pages/order-summary/order-summary";
import PaymentSummary from "./pages/payment-summary/payment-summary";
import MyRewards from "./pages/my-rewards/my-rewards";
import Help from "./pages/help/help";
import GeneralEnquiry from "./pages/general-enquiry/general-enquiry";
import History from "./pages/order-history/history";
import RatingsReviews from "./pages/ratings-reviews/ratings-reviews";
import RaisedQuery from "./pages/raised-query/raised-query";
import Feedback from "./pages/feedback/feedback";
import SearchLocality from "./pages/search-locality/search-locality";
import RestaurantList from "./pages/restaurant-list/restaurant-list";
import PaymentProcessing from "./pages/payment-processing/paymentProcessing";
import SearchLocation from "./pages/search-location/search-location";
import ScratchCardDetails from "./pages/scratchcard-details/scratchcard-details";

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RestaurantList />} />
          <Route path="/outlet-list" element={<RestaurantList />} />
          <Route path="/search-city" element={<Search />} />
          <Route path="/search-locality" element={<SearchLocality />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/pay-bill" element={<Paybill />} />
          <Route path="/pay-bill/:outletId" element={<Paybill />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/outlet-detail" element={<OutletDetail />} />
          {/* <Route path="/bill-amount" element={<BillAmount />} /> */}
          <Route path="/break-up" element={<BreakUp />} />
          <Route path="/payment-summary" element={<PaymentSummary />} />
          <Route path="/my-rewards" element={<MyRewards />} />
          <Route path="/help" element={<Help />} />
          <Route path="/general-enquiry" element={<GeneralEnquiry />} />
          <Route path="order-history" element={<History />} />
          <Route path="rating-review" element={<RatingsReviews />} />
          <Route path="raised-query" element={<RaisedQuery />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="/payment-processing" element={<PaymentProcessing />} />
          <Route path="/search-location" element={<SearchLocation />} />
          <Route path="/scratchcard-details" element={<ScratchCardDetails />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
